import React, { useState, useEffect } from 'react';
import { Button, Modal, Input } from '@douyinfe/semi-ui';
import styles from './index.module.scss';

const ColorPicker = ({ value, onChange, onClose, visible = false }) => {
    const [color, setColor] = useState(value || '#000000');
    const [pickerVisible, setPickerVisible] = useState(visible);
    const [historyColors, setHistoryColors] = useState(() => {
        const saved = localStorage.getItem('colorPickerHistoryColors');
        return saved ? JSON.parse(saved) : [];
    });

    const colors = [
        'transparent', '#000000', '#434343', '#666666', '#999999', '#b7b7b7', '#cccccc', '#d9d9d9', '#ffffff',
        '#ff0000', '#ff4d4f', '#ff7875', '#ff9c9c', '#ffb5b5', '#ffccc7', '#ffe2dd', '#fff1f0',
        '#0050b3', '#096dd9', '#1890ff', '#40a9ff', '#69c0ff', '#91d5ff', '#bae7ff', '#e6f7ff',
        '#237804', '#389e0d', '#52c41a', '#73d13d', '#95de64', '#b7eb8f', '#d9f7be', '#f6ffed'
    ];

    useEffect(() => {
        setColor(value || '#000000');
    }, [value]);

    useEffect(() => {
        setPickerVisible(visible);
    }, [visible]);

    const handleChange = (newColor) => {
        setColor(newColor);
        if (onChange) {
            onChange(newColor);
        }
        if (!historyColors.includes(newColor)) {
            const newHistoryColors = [newColor, ...historyColors.slice(0, 9)];
            setHistoryColors(newHistoryColors);
            localStorage.setItem('colorPickerHistoryColors', JSON.stringify(newHistoryColors));
        }
        setPickerVisible(false);
    };

    return (
        <div className={styles.colorPicker}>
            <div
                className={styles.previewBox}
                onClick={() => setPickerVisible(true)}
                style={{
                    width: '32px',
                    height: '32px',
                    backgroundColor: color,
                    border: '1px solid var(--semi-color-border)',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    background: color === 'transparent' ?
                        'repeating-conic-gradient(#CCCCCC 0% 25%, transparent 0% 50%) 50% / 8px 8px' :
                        color
                }}
            />
            <Modal
                title="选择颜色"
                visible={pickerVisible}
                onCancel={() => {
                    setPickerVisible(false);
                    if (onClose) onClose();
                }}
                footer={null}
                width={400}
                centered
            >
                <div style={{ padding: '16px' }}>
                    <div style={{ display: 'grid', gap: '8px' }}>
                        {historyColors.length > 0 && (
                            <div>
                                <div style={{ marginBottom: '4px', color: 'var(--semi-color-text-2)' }}>最近使用</div>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '4px' }}>
                                    {historyColors.map((color, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                width: '32px',
                                                height: '32px',
                                                backgroundColor: color,
                                                cursor: 'pointer',
                                                border: '1px solid var(--semi-color-border)',
                                                borderRadius: '4px',
                                                background: color === 'transparent' ?
                                                    'repeating-conic-gradient(#CCCCCC 0% 25%, transparent 0% 50%) 50% / 8px 8px' :
                                                    color
                                            }}
                                            onClick={() => handleChange(color)}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                        <div>
                            <div style={{ marginBottom: '4px', color: 'var(--semi-color-text-2)' }}>预设颜色</div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: '4px' }}>
                                {colors.map((color, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            backgroundColor: color,
                                            cursor: 'pointer',
                                            border: '1px solid var(--semi-color-border)',
                                            borderRadius: '4px',
                                            background: color === 'transparent' ?
                                                'repeating-conic-gradient(#CCCCCC 0% 25%, transparent 0% 50%) 50% / 8px 8px' :
                                                color
                                        }}
                                        onClick={() => handleChange(color)}
                                    />
                                ))}
                            </div>
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <div style={{ marginBottom: '4px', color: 'var(--semi-color-text-2)' }}>自定义颜色</div>
                            <Input
                                type="color"
                                value={color === 'transparent' ? '#000000' : color}
                                onChange={handleChange}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export { ColorPicker };
export default ColorPicker;